import React from "react";
import pageStyles from "../styles/PageLayout.module.css";
import PageHeader from "../shared/PageHeader";
import PageContent from "../shared/PageContent";
import UsersSection from "../sections/UsersSection";

export function UsersPage({ users }) {
  return (
    <div className={pageStyles.page}>
      <PageHeader
        title="Пользователи"
        description="Ищите пользователей по id, проверяйте состояние аккаунта и вручную меняйте баланс или подписку."
      />
      <PageContent>
        <UsersSection mode="page" state={users.state} actions={users.actions} />
      </PageContent>
    </div>
  );
}

export default UsersPage;
